import styled, { css } from 'styled-components';

import Tooltip from 'components/utils/Tooltip';

import animations from 'styles/animations';
import colors from 'styles/colors';

export const Container = styled.div`
  margin-top: 0.5rem;
  width: 100%;
`;

export const Label = styled.label`
  color: ${colors.gray300};
  display: flex;
  font-size: 0.75rem;
  margin-bottom: 0.5rem;
`;

export interface IFieldContainerProps {
  backgroundColor?: string;
  height?: string;
  isErrored?: boolean;
  isFilled: boolean;
  isFocused: boolean;
  isReadOnly?: boolean;
}

export const FieldContainer = styled.div<IFieldContainerProps>`
  align-items: center;
  background: ${props =>
    props.backgroundColor ? props.backgroundColor : colors.white900};
  border: 1px solid ${colors.gray100};
  border-radius: 0.5rem;
  display: flex;
  height: ${props => (props.height ? props.height : '9rem')};
  overflow: hidden;
  position: relative;
  width: 100%;
  ${props =>
    props.isErrored &&
    css`
      border-color: ${colors.red500};
    `}
  ${props =>
    props.isFocused &&
    css`
      border-color: ${colors.cyan900};
      color: ${colors.cyan900};
    `}
  ${props =>
    props.isFilled &&
    css`
      color: ${colors.cyan900};
    `}
    ${props =>
    props.isReadOnly &&
    css`
      background-color: ${colors.background};
      border-color: ${colors.background};
    `}
`;

interface ITextareaProps {
  height?: string;
}

export const Textarea = styled.textarea<ITextareaProps>`
  background: ${colors.transparent};
  border: 0;
  color: ${colors.gray500};
  flex: 1;
  font-size: 0.85rem;
  height: ${props => (props.height ? props.height : '9rem')};
  max-width: 100%;
  min-width: 0;
  padding: 0.75rem;
  resize: none;
  &:read-only {
    animation: ${animations.shimmer} 2s infinite linear;
    background: linear-gradient(to right, #f2f3f5 4%, #ebeced 25%, #f2f3f5 36%);
    background-size: 1000px 100%;
    cursor: not-allowed;
  }
`;

export const Error = styled(Tooltip)``;
